var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"chatBox"}},[_c('iframe',{style:({ height: _vm.frameHeight + 'px' }),attrs:{"id":"iframeChatBox","src":_vm.chatUrl,"frameborder":"0"}})])}
var staticRenderFns = []

export { render, staticRenderFns }